/**
 * API services for Nhanh.vn integration.
 */

export const fetchDepotsApi = async ({ appId, businessId, accessToken }) => {
  const url = `https://pos.open.nhanh.vn/v3.0/business/depot?appId=${appId}&businessId=${businessId}`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchProductsApi = async ({ appId, businessId, accessToken }) => {
  const url = `https://pos.open.nhanh.vn/v3.0/product/list?appId=${appId}&businessId=${businessId}`;

  let allProducts = [];
  let page = 1;
  let totalPages = 1;
  const size = 1000;

  do {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        paginator: {
          size: size,
          page: page,
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    if (result && result.code === 1 && result.data) {
      let productsPage = [];
      const dataProducts = result.data;
      if (Array.isArray(dataProducts)) {
        productsPage = dataProducts;
      } else if (dataProducts && typeof dataProducts === "object") {
        const nestedList =
          dataProducts.products || dataProducts.list || dataProducts.items;
        if (Array.isArray(nestedList)) {
          productsPage = nestedList;
        } else {
          productsPage = Object.values(dataProducts).filter(
            (item) =>
              item && typeof item === "object" && (item.id || item.name),
          );
        }
      }

      allProducts = [...allProducts, ...productsPage];
      totalPages =
        result.paginator?.pages ||
        result.data?.paginator?.pages ||
        result.paginator?.totalPages ||
        result.data?.paginator?.totalPages ||
        result.totalPages ||
        result.data?.totalPages ||
        (result.data && (result.data.pages || result.data.totalPages)) ||
        1;
      page++;
    } else {
      break;
    }
  } while (page <= totalPages);

  return {
    code: 1,
    data: allProducts,
  };
};

export const fetchOrdersApi = async ({
  appId,
  businessId,
  accessToken,
  fromDate,
  toDate,
  statuses,
  page = 1,
  size = 1000,
  nextId = null,
}) => {
  const url = `https://pos.open.nhanh.vn/v3.0/order/list?appId=${appId}&businessId=${businessId}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      filters: {
        createdAtFrom: fromDate || "",
        createdAtTo: toDate || "",
        ...(statuses && statuses.length > 0 ? { statuses } : {}),
      },
      paginator: {
        size: size,
        ...(nextId ? { next: { id: nextId } } : { page: page }),
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const fetchBillsApi = async ({
  appId,
  businessId,
  accessToken,
  fromDate,
  toDate,
}) => {
  const url = `https://pos.open.nhanh.vn/v3.0/bill/list?appId=${appId}&businessId=${businessId}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: accessToken || "",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      filters: {
        fromDate: fromDate || "",
        toDate: toDate || "",
        modes: [2, 3, 4, 5, 6, 7, 8, 9, 10],
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

